// extracted by mini-css-extract-plugin
export default {"menuWrapper":"ProjectMenu_menuWrapper__AlqrF","menuButton":"ProjectMenu_menuButton__1ftsz","dropdown":"ProjectMenu_dropdown__0mnlB","item":"ProjectMenu_item__xjVMZ"};